import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

import { makeStyles, Grid } from "@material-ui/core";

import { PAGES } from "../../pages";
import { USER_ROLES } from "../../services/constants";
import { VerticalTabs } from "../../components/VerticalTabs";

const TABS = [
  {
    name: "My profile",
    path: `${PAGES.workspace.index}${PAGES.workspace.settings.index}`,
    permissions: [USER_ROLES.super_pm, USER_ROLES.pm, USER_ROLES.bop],
  },
  {
    name: "Company settings",
    path: `${PAGES.workspace.index}${PAGES.workspace.settings.index}/${PAGES.workspace.settings.companySettings}`,
    permissions: [USER_ROLES.super_pm, USER_ROLES.pm],
  },
  {
    name: "Portfolio profile",
    path: `${PAGES.workspace.index}${PAGES.workspace.settings.index}/${PAGES.workspace.settings.portfolioProfile}`,
    permissions: [USER_ROLES.super_pm],
  },
  {
    name: "Portfolio registration",
    path: `${PAGES.workspace.index}${PAGES.workspace.settings.index}/${PAGES.workspace.settings.portfolioRegistration}`,
    permissions: [USER_ROLES.super_pm],
  },
  {
    name: "Users & permissions",
    path: `${PAGES.workspace.index}${PAGES.workspace.settings.index}/${PAGES.workspace.settings.usersPermission}`,
    permissions: [USER_ROLES.super_pm, USER_ROLES.pm],
  },
  {
    name: "Alerts & notifications",
    path: `${PAGES.workspace.index}${PAGES.workspace.settings.index}/${PAGES.workspace.settings.alertsNotifications}`,
    permissions: [USER_ROLES.super_pm, USER_ROLES.pm],
  },
  {
    name: "PRaaS integrations",
    path: `${PAGES.workspace.index}${PAGES.workspace.settings.index}/${PAGES.workspace.settings.praasIntegrations}`,
    permissions: [USER_ROLES.super_pm, USER_ROLES.pm],
  },
  {
    name: "Support",
    path: `${PAGES.workspace.index}${PAGES.workspace.settings.index}/${PAGES.workspace.settings.support}`,
    permissions: [USER_ROLES.super_pm, USER_ROLES.pm],
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2.5)}px ${theme.spacing(6.5)}px`,
  },
}));

export const SettingsPageLayout = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [tabs, setTabs] = useState([]);
  const { cluster } = useSelector((state) => state.selectCSC);

  useEffect(() => {
    let activeTabs = TABS.filter((tab) => tab.permissions.includes(cluster?.user_role));
    setTabs(activeTabs);
    const activeTab = activeTabs.find((tab) => tab.path === location.pathname);

    if (!activeTab) {
      setTab(0);
      navigate(TABS[0].path);
    } else {
      setTab(activeTabs.map((activeTab) => activeTab.name).indexOf(activeTab.name));
    }
  }, [location.pathname, cluster]);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={2}>
        <VerticalTabs
          tab={tab}
          setTab={(tab) => {
            setTab(tab);
            navigate(tabs[tab].path);
          }}
          tabNames={tabs.map((tab) => tab.name)}
        />
      </Grid>
      <Grid item xs={10}>
        <Outlet />
      </Grid>
    </Grid>
  );
};
